import { cut } from "@/helper/getCut";

export function getCount(list, key, isCut) {
	if (isCut) return cut(list.length);
	return list.length;
}
